import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import * as actions from '../../../../../search/searchDucks';
import SearchField from './SearchField.jsx';

const DEBOUNCE_TIMEOUT = 300;

const { SEARCH_FORM } = actions;

let debounceSubmitTimer;
const debounceSubmit = handleSubmit => () => {
  clearTimeout(debounceSubmitTimer);
  debounceSubmitTimer = setTimeout(() => {
    handleSubmit();
  }, DEBOUNCE_TIMEOUT);
};

const HeaderSearchForm = ({ handleSubmit }) => (
  <div className="search">
    <form>
      <i className="ic ic-search"/>
      <Field
        component={SearchField}
        name="text"
        onChange={debounceSubmit(handleSubmit)}
      />
    </form>
  </div>
);

const HeaderSearchReduxForm = reduxForm({
  form: SEARCH_FORM,
  enableReinitialize: true,
})(HeaderSearchForm);

const HeaderSearch = ({ searchDocuments, ...props }) => (
  <HeaderSearchReduxForm {...props} onSubmit={searchDocuments}/>
);

const mapStateToProps = ({ search: { text } }) => ({ initialValues: { text } });

export default connect(mapStateToProps, actions)(HeaderSearch);



// WEBPACK FOOTER //
// ./book/src/commons/components/layout/header/search/HeaderSearch.jsx